import React from 'react'

import DotLoader from '../../../Loader/DotLoader'
import { Wrapper } from './styles/Wrapper'

export default function TournamentsLoader() {
  return (
    <Wrapper>
      <DotLoader />
    </Wrapper>
  )
}
